import Model from "./model";
import IRepo from "../interfaces/repo";
import Collection from "./collection";

export default class ModelCollection<T extends Model> extends Collection<T> {
  add(item: T): void {
    super.add(item);
    const repo: IRepo<T> = (<any>item.constructor).repo;
    if (repo) {
      repo.add(item);
    }
    item.addCollectionReference(this);
  }

  addForKey(key: string, item: T): void {
    super.add(item);
    const repo: IRepo<T> = (<any>item.constructor).repo;
    if (repo) {
      repo.addForKey(key, item);
    }
    item.addCollectionReference(this);
  }

  remove(item: T): void {
    item.removeCollectionReference(this);
    super.remove(item);
  }

  destroy(item: T): void {
    this.remove(item)
    item.destroy()
  }

  destroyAll(): void {
    this.refresh(() => {
      this._items.forEach(item => {
        this.remove(item);
        item.destroy()
      });
    });
  }

  asJson(): object[] {
    return this.all.map(item => item.asJson());
  }
}
